import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  range_allTime: {
    id: 'range_allTime',
    defaultMessage: 'All time',
  },
  selectRange: {
    id: 'selectRange',
    defaultMessage: 'Select date range',
  },
  noTransactions: {
    id: 'noTransactions',
    defaultMessage: 'No transactions where found to match your search',
  },
  noTransactionsDesc: {
    id: 'noTransactionsDesc',
    defaultMessage: 'Try modifying your search criteria',
  },
});

export default { ...globalIntl, ...m };
